const { serialize } = require("../../utils");
export default {
  namespaced: true,
  state: {
    path: "aljabr/camps",
  },
  actions: {
    get({ dispatch, state, rootState }, options) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}`,
          method: "GET",
          data: {},
        },
        { root: true }
      );
    },
    getById({ dispatch, state, rootState }, id) {
      return dispatch("FETCH", { url: `${state.path}/id/${id}`, method: "GET", data: {} }, { root: true });
    },
    add({ dispatch, state, rootState }, data) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/add`,
          method: "POST",
          data,
        },
        { root: true }
      );
    },
    addGroup({ dispatch, state, rootState }, data) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/add-group`,
          method: "POST",
          data,
        },
        { root: true }
      );
    },
    getBranchGroups({ dispatch, state, rootState }, branchId) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/branch-groups/${branchId}`,
          method: "GET",
          data: {},
        },
        { root: true }
      );
    },
    addStudent({ dispatch, state, rootState }, data) {
      return dispatch("FETCH", { url: `${state.path}/add-student`, method: "POST", data }, { root: true });
    },
    updateGroup({ dispatch, state, rootState }, data) {
      return dispatch("FETCH", { url: `${state.path}/update-group`, method: "POST", data }, { root: true });
    },
    addPayment({ dispatch, state, rootState }, data) {
      return dispatch("FETCH", { url: `${state.path}/add-payment`, method: "POST", data }, { root: true });
    },
    updateParentStatus({ dispatch, state, rootState }, data) {
      return dispatch("FETCH", { url: `${state.path}/update-parent-status`, method: "POST", data }, { root: true });
    },
    changeStudentGroup({ dispatch, state, rootState }, data) {
      return dispatch("FETCH", { url: `${state.path}/change-student-group`, method: "POST", data }, { root: true });
    },
    addSquad({ dispatch, state, rootState }, data) {
      return dispatch("FETCH", { url: `${state.path}/add-squad`, method: "POST", data }, { root: true });
    },
    updateSquad({ dispatch, state, rootState }, data) {
      return dispatch("FETCH", { url: `${state.path}/update-squad`, method: "POST", data }, { root: true });
    },
    deleteSquad({ dispatch, state, rootState }, data) {
      return dispatch("FETCH", { url: `${state.path}/delete-squad`, method: "POST", data }, { root: true });
    },
    updateSquadSchedule({ dispatch, state, rootState }, data) {
      return dispatch("FETCH", { url: `${state.path}/update-squad-schedule`, method: "POST", data }, { root: true });
    },
    addStudentToSquad({ dispatch, state, rootState }, data) {
      return dispatch("FETCH", { url: `${state.path}/add-student-to-squad`, method: "POST", data }, { root: true });
    },
    removeStudentFromSquad({ dispatch, state, rootState }, data) {
      return dispatch("FETCH", { url: `${state.path}/remove-student-from-squad`, method: "POST", data }, { root: true });
    },
    getTeachers({ dispatch, state, rootState }) {
      return dispatch("FETCH", { url: `${state.path}/get-teachers`, method: "GET", data: {} }, { root: true });
    },
    addSchedule({ dispatch, state, rootState }, data) {
      return dispatch("FETCH", { url: `${state.path}/add-schedule`, method: "POST", data }, { root: true });
    },
    updateSchedule({ dispatch, state, rootState }, data) {
      return dispatch("FETCH", { url: `${state.path}/update-schedule`, method: "POST", data }, { root: true });
    },
    deleteSchedule({ dispatch, state, rootState }, data) {
      return dispatch("FETCH", { url: `${state.path}/delete-schedule`, method: "POST", data }, { root: true });
    },
    addStudentToStudents({ dispatch, state, rootState }, data) {
      return dispatch("FETCH", { url: `${state.path}/add-student-to-students`, method: "POST", data }, { root: true });
    },
    updateStudentOnStudents({ dispatch, state, rootState }, data) {
      return dispatch("FETCH", { url: `${state.path}/update-student-on-students`, method: "POST", data }, { root: true });
    },
    deleteStudentFromStudents({ dispatch, state, rootState }, data) {
      return dispatch("FETCH", { url: `${state.path}/delete-student-from-students`, method: "POST", data }, { root: true });
    },
    confirmParent({ dispatch, state, rootState }, data) {
      return dispatch("FETCH", { url: `${state.path}/confirm-parent`, method: "POST", data }, { root: true });
    },
    rejectParent({ dispatch, state, rootState }, data) {
      return dispatch("FETCH", { url: `${state.path}/reject-parent`, method: "POST", data }, { root: true });
    },
    addHouse({ dispatch, state, rootState }, data) {
      return dispatch("FETCH", { url: `${state.path}/add-house`, method: "POST", data }, { root: true });
    },
    updateHouse({ dispatch, state, rootState }, data) {
      return dispatch("FETCH", { url: `${state.path}/update-house`, method: "POST", data }, { root: true });
    },
    approveRequest({ dispatch, state, rootState }, data) {
      return dispatch("FETCH", { url: `${state.path}/approve-request`, method: "POST", data }, { root: true });
    },
    rejectRequest({ dispatch, state, rootState }, data) {
      return dispatch("FETCH", { url: `${state.path}/reject-request`, method: "POST", data }, { root: true });
    },
  },
};
